<template>
    <b-form-radio
    value="true"
    v-model="pack.active"
    button button-variant="white"
    class="w-100 h-100 pack-radio"
    :class="{ 'checked' : pack.active, 'unchecked' : !pack.active }"
    @change="radioChange"
    >
        <div class="h-100 w-100 border-bottom mb-3">
            <div class="d-flex justify-content-start">
                <img src="../assets/images/icons/tick/red-checked-tick.svg" alt="Case cochée" width="40" height="40" id="checked-tick" class="tick" />
                <img src="../assets/images/icons/tick/red-unchecked-tick.svg" alt="Case non cochée" width="40" height="40" id="unchecked-tick" class="tick" />
            </div>

            <img :src="pack.image.src" :alt="pack.image.alt" width="50" height="auto" class="mb-2" />

            <h2 class="h4 text-primary mb-5">{{ pack.text }}</h2>

            <ul class="pl-3 text-left mb-5">
                <li v-if="pack.packIncluded" class="text-primary font-weight-bold d-flex align-items-start">
                    <img src="@/assets/images/icons/tick/tick.svg" alt="Flèche rouge vers la droite" width="20" height="20" class="mr-2">
                    {{ pack.packIncluded }} +
                </li>
                <li v-for="(advantage, index) in pack.advantages" :key="index" class="d-flex align-items-start">
                    <img src="@/assets/images/icons/tick/tick.svg" alt="Flèche rouge vers la droite" width="20" height="20" class="mr-2">
                    {{ advantage }}
                </li>

                <div v-if="legalForm === 'Auto-Entrepreneur / Micro-entreprise'">
                    <li v-for="(selfEmployedAdvantage, index) in pack.selfEmployedAdvantages" :key="index" class="d-flex align-items-start">
                        <img src="@/assets/images/icons/tick/tick.svg" alt="Flèche rouge vers la droite" width="20" height="20" class="mr-2">
                        {{ selfEmployedAdvantage }}
                    </li>
                </div>
            </ul>

            <b class="text-danger mb-5 text-left d-block" v-if="pack.announcement">{{ pack.announcement }}</b>
        </div>

        <b class="h4 font-weight-bold">{{ pack.price }}{{ services.currency }} {{ services.tva }}</b>
    </b-form-radio>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            index: {
                type: Number,
                required: true
            },
            pack: {
                type: Object,
                required: true
            },
            legalForm: {
                type: String,
                required: true
            }
        },
        methods: {
            radioChange() {
                this.$emit('radioChange', this.index);
            }
        },
        computed: {
            ...mapState(['services'])
        }
    }
</script>

<style lang="scss">
    .pack-radio label
    {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 1rem;
        border: 3px solid black;

        &:hover
        {
            border: 3px solid #ad233f;
            background-color: rgb(250, 250, 250);
        }
    }

    .checked label
    {
        border-color: #ad233f;
        background-color: rgb(250, 250, 250);

        #checked-tick
        {
            display: block;
        }
    }

    .unchecked label
    {
        #unchecked-tick
        {
            display: block;
        }
    }

    .tick
    {
        display: none;
    }
</style>
